<template>
  <!-- 新闻中心 -->
  <div class="CenterWrap contentBox">
    <router-link class="index-title" :to="{ path: CenterInfo.url, query:{ name: CenterInfo.name, topicId: CenterInfo.id } }" target="_blank">{{ CenterInfo.name }}</router-link>
    <div class="content">
      <ul>
        <li v-for="(item,index) in CenterData" :key="index">
          <router-link :to="{ path: '/newsDetails', query:{ name: CenterInfo.name, subName: item.seminarSubTopicName, newsId: item.id, topicId: CenterInfo.id } }">
            <div class="mtpic"><img :src="item.imagePath" /></div>
            <div class="mtdes">
              <h2 class="Linebreak">{{ item.name }}</h2>
              <p class="time">{{ item.revisabilityDate }}</p>
              <p class="abstract Linebreak-more">{{ item.abstract }}</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <router-link class="index-more" :to="{ path: CenterInfo.url, query:{ name: CenterInfo.name, topicId: CenterInfo.id } }">查看更多</router-link>
  </div>
</template>

<script>
  export default{
    name: 'IndexNewsCenter',
    props: {
      CenterInfo: {
        type: Object,
        default: () => {}
      },
      CenterData: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .CenterWrap .content{
      margin: 40px auto 0;
    }

    .CenterWrap .content ul{
      display: flex;
      flex-wrap: wrap;
    }

    .CenterWrap li{
      width: 580px;
      margin-bottom: 30px;
    }

    .CenterWrap li a{
      display: flex;
    }

    .CenterWrap li:nth-child(2n){
      margin-left: 40px;
    }

    .CenterWrap li .mtpic{
      margin-right: 20px;
    }

    .mtpic img{
      width: 210px;
      height: 140px;
    }

    .mtdes{
      height: 140px;
      overflow: hidden;
    }

    .mtdes h2{
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      margin-bottom: 15px;
      height: 48px;
    }

    .mtdes .time{
      display: none;
    }

    .mtdes>p{
      font-size: 14px;
      line-height: 24px;
      color: #ffffff;
      text-indent: 28px;
      max-height: 72px;
    }

    .CenterWrap .index-more{
      margin: 40px auto 95px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .CenterWrap .content{
      overflow: hidden;
      margin: 0;
    }

    /* 内容 */
    .CenterWrap .content ul{
      padding-bottom: .3rem;
      background: rgba(0,0,0,.3);
      border-radius: 3px;
    }

    .CenterWrap li{
      padding: 0 .3rem;
    }

    .CenterWrap li a{
      display: flex;
      padding: .3rem 0;
      border-bottom: 1px solid #9fc1c9;
    }

    .mtpic{
      margin-right: .3rem;
    }

    .CenterWrap li img{
      width: 2.2rem;
      height: 1.4rem;
    }

    .CenterWrap li h2{
      font-size: .28rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: .44rem;
      max-height: 1.32rem;
      color: #ffffff;
      -webkit-line-clamp: 3 !important;
    }

    .mtdes>p{
      font-size: .28rem;
      line-height: .44rem;
      color: #ffffff;
      margin-top: .1rem;
    }

    .mtdes .abstract{
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexNewsCenter.vue